import { useBareUrlParam } from './useBareUrlParam';
import type { MCPEnforcementView } from '@kirin/api-client/contracts/mcp';

/**
 * Bare URL param for the All servers / New / Blocked chips (KIR-4482). Like
 * the source filter's `pr`, it lives outside DataTable's `inv-mcp.` namespace
 * because the chips are a bespoke control, not a registered column.
 */
export const MCP_ENFORCEMENT_VIEW_URL_PARAM = 'ev';

export function readEnforcementViewFromUrl(
  searchParams: URLSearchParams
): MCPEnforcementView | null {
  return parseEnforcementView(searchParams.get(MCP_ENFORCEMENT_VIEW_URL_PARAM));
}

function parseEnforcementView(raw: string | null): MCPEnforcementView | null {
  return raw === 'new' || raw === 'blocked' ? raw : null;
}

/** Reads/writes the enforcement chip selection from the URL (`null` = All). */
export function useMcpEnforcementView(): {
  view: MCPEnforcementView | null;
  setView: (next: MCPEnforcementView | null) => void;
} {
  const [view, setView] = useBareUrlParam(
    MCP_ENFORCEMENT_VIEW_URL_PARAM,
    parseEnforcementView
  );
  return { view, setView };
}
